import { render, staticRenderFns } from "./BtnWhatsapp.vue?vue&type=template&id=f11af360"
import script from "./BtnWhatsapp.vue?vue&type=script&lang=js"
export * from "./BtnWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./BtnWhatsapp.vue?vue&type=style&index=0&id=f11af360&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports